import { SelectedExperiences, SelectedMemberships, SelectedMerchandise } from "types";
import { SelectionState } from "../hooks/useSelection";

export const getSelectedExperiences = (selectionState: SelectionState): SelectedExperiences => {
    return { all: selectionState.all, experiences: selectionState.selected };
};

export const getSelectedMemberships = (selectionState: SelectionState): SelectedMemberships => {
    return { all: selectionState.all, memberships: selectionState.selected };
};

export const getSelectedMerchandise = (selectionState: SelectionState): SelectedMerchandise => {
    return { all: selectionState.all, merchandise: selectionState.selected };
};

export const getSelectionState = (
    selectedProducts: SelectedExperiences | SelectedMemberships | SelectedMerchandise,
): SelectionState => {
    if ("memberships" in selectedProducts) {
        return { all: selectedProducts.all, selected: selectedProducts.memberships };
    }

    if ("merchandise" in selectedProducts) {
        return { all: selectedProducts.all, selected: selectedProducts.merchandise };
    }

    return { all: selectedProducts.all, selected: selectedProducts.experiences };
};
